// extracted by mini-css-extract-plugin
export default {"dashboard-wrapper":"dashboard-wrapper_Rw9PE"};